import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider } from "react-redux";
import { Switch } from "react-router";
import mainRoutes from './routes/main';
import Redirect from "react-router-dom/es/Redirect";
import { store } from "./redux/store";
import { Helmet } from "react-helmet";

import {} from './assets/images/myicon.png'



const routes = <Switch>
    {mainRoutes.map((prop, key) => {
        if (prop.redirect)
            return <Redirect from={prop.path} to={prop.to} key={key} />;
        return <Route path={prop.path} component={prop.component}
            exact={prop.exact} key={key} />;
    })}
</Switch>;



const Main = () => (
    <Provider store={store}>
        <div>
            <Helmet>
                <meta name="robots" content="nofollow" />
                {/* <link rel="shortcut icon" type="image/png" href="http://icons.iconarchive.com/icons/graphicloads/100-flat/256/home-icon.png"></link> */}

                <link rel="icon" type="image/png" href="assets/images/myicon.png"/>
            </Helmet>
            <BrowserRouter>
                {routes}
            </BrowserRouter>
        </div>
    </Provider>
);

export default Main;


// WEBPACK FOOTER //
// ./src/Main.js